export var DisabledUI;
(function (DisabledUI) {
    DisabledUI["FromAmount"] = "fromAmount";
    DisabledUI["FromToken"] = "fromToken";
    DisabledUI["ToAddress"] = "toAddress";
    DisabledUI["ToToken"] = "toToken";
})(DisabledUI || (DisabledUI = {}));
export var HiddenUI;
(function (HiddenUI) {
    HiddenUI["Appearance"] = "appearance";
    // FromAmount = 'fromAmount',
    HiddenUI["Language"] = "language";
    HiddenUI["PoweredBy"] = "poweredBy";
    HiddenUI["ToAddress"] = "toAddress";
    HiddenUI["History"] = "history";
    // ToToken = 'toToken',
})(HiddenUI || (HiddenUI = {}));
export var RequiredUI;
(function (RequiredUI) {
    RequiredUI["ToAddress"] = "toAddress";
})(RequiredUI || (RequiredUI = {}));
